import { faCalendarExclamation as falCalendarExclamation, faCloudRain as falCloudRain, faExclamationCircle as falExclamationCircle, faExclamationTriangle as falExclamationTriangle, faGlobe as falGlobe, faTimes as falTimes, faTrashAlt as falTrashAlt, faUserCircle as falUserCircle } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown as farAngleDown, faAngleUp as farAngleUp, faCalendarDay as farCalendarDay, faCalendarDays as farCalendarDays, faCheck as farCheck, faChevronRight as farChevronRight, faDollarSign as farDollarSign, faExclamationCircle as farExclamationCircle, faExclamationTriangle as farExclamationTriangle, faFileAlt as farFileAlt, faInfoCircle as farInfoCircle, faMoneyCheckAlt as farMoneyCheckAlt, faPen as farPen, faQuestionCircle as farQuestionCircle, faSpinner as farSpinner, faSync as farSync, faSyncAlt as farSyncAlt, faTimes as farTimes, faUniversity as farUniversity } from '@fortawesome/pro-regular-svg-icons';
export { faCheck as FAS_CHECK, faExclamationCircle as FAS_EXCLAMATION_CIRCLE, faExternalLink as FAS_EXTERNAL_LINK, faTimes as FAS_TIMES, faCircleCheck as FAS_CIRCLE_CHECK } from '@fortawesome/free-solid-svg-icons';
export { faCalendarAlt as FAS_CALENDAR_ALT } from '@fortawesome/free-solid-svg-icons';
/*
 * export const FAS_TIMES = fasTimes
 * export const FAS_EXCLAMATION_CIRCLE = fasExclamationCircle
 * export const FAS_EXTERNAL_LINK = fasExternalLink
 * export const FAS_CHECK = fasCheck
 * export const FAS_CALENDAR_ALT = fasCalendarAlt
 */
export const FAR_CALENDAR_DAY = farCalendarDay;
export const FAR_SYNC = farSync;
export const FAR_CHEVRON_RIGHT = farChevronRight;
export const FAR_CALENDAR_DAYS = farCalendarDays;
export const FAR_DOLLAR_SIGN = farDollarSign;
export const FAR_CHECK = farCheck;
export const FAR_EXCLAMATION_CIRCLE = farExclamationCircle;
export const FAR_ANGLE_DOWN = farAngleDown;
export const FAR_EXCLAMATION_TRIANGLE = farExclamationTriangle;
export const FAR_QUESTION_CIRCLE = farQuestionCircle;
export const FAR_ANGLE_UP = farAngleUp;
export const FAR_UNIVERSITY = farUniversity;
export const FAR_FILE_ALT = farFileAlt;
export const FAR_PEN = farPen;
export const FAR_SYNC_ALT = farSyncAlt;
export const FAR_INFO_CIRCLE = farInfoCircle;
export const FAR_MONEY_CHECK_ALT = farMoneyCheckAlt;
export const FAR_TIMES = farTimes;
export const FAR_SPINNER = farSpinner;
export const FAL_EXCLAMATION_CIRCLE = falExclamationCircle;
export const FAL_EXCLAMATION_TRIANGLE = falExclamationTriangle;
export const FAL_CALENDAR_EXCLAMATION = falCalendarExclamation;
export const FAL_USER_CIRCLE = falUserCircle;
export const FAL_GLOBE = falGlobe;
export const FAL_CLOUD_RAIN = falCloudRain;
export const FAL_TRASH_ALT = falTrashAlt;
export const FAL_TIMES = falTimes;
